import React, { useEffect, useState, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { Field, useFormikContext } from "formik";
import AsyncSelect from "react-select/async";
import clsx from "clsx";
import InputLabel from "@material-ui/core/InputLabel";
import useStyles from "assets/jss/material-dashboard-react/components/customSelectStyle";
import ErrorMessage from "@Components/ErrorMessage";
import { useTranslation } from "react-i18next";
import eightAxios from "configs/axiosConfig";
import {
  fetchDataFromApi,
  getMultipleObjectsForMultiSelect,
  getObjectFromCurrentValue,
  getOptionFromCurrentValue,
  mapOldOptionsToNewOptions,
} from "utils";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ROLEMAPPING_FETCH_URL } from "configs/constants";
import { ZONE_FETCH_URL } from "configs/constants";
import HoverTooltip from "@Components/Tooltip/HoverTooltip";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";

const ReactSelect = (props) => {
  const {
    name,
    showSelectedObject, // this props is used to display the estate selectedobject value.
    label,
    required,
    errorMessage,
    proxyUrl,
    id,
    isAllowablesEnabled,
    isPaginationEnabled,
    paginated,
    optionsDependsOn,
    outerOptions,
    groupedOptions,
    discardOptionsByName,
    discardOptionsByProperties,/*Add new prop which is passed to new select component that filter options by given properties*/
    isMultiSelect,
    disabled,
    clear,
    hasNotSupervisor, //this props is used for role dropdown which depends on wrokergroup dropdown,if role is not supervisor then the workergroup is empty and disabled.
    setClear,
    dynamicLabel,
    hasNoEstates,
    getValue,
    value,
    filterOnType,
    clearAllowables,
    hasAllSelected,
    selectedDefaultObjectValue,
    isPageEnabled,
    isPageSizeEnabled,
    nationalityInfoIcon,
    supervisorInfoIcon,

  } = props;

  const [selectedValue, setSelectedValue] = useState([]);
  const [options, setOptions] = useState([]);
  const [fetchOptions, setFetchOptions] = useState([]);
  const [formattedGroupedOptions, setFormattedGroupedOptions] = useState([]);
  const [optionDependsOnValue, setOptionDependsOnValue] = useState(null);
  const [fetched, setFetched] = useState(false);
  const [prevState, setPrevState] = useState(null); //this state is used for selected options mapping in edit form, reset child dropdown on parent value change
  const [hasOptionFetched, setHasOptionFetched] = useState(false); /*this state is used to fetch the options of the dropdown when needed*/
  const [hasDependentCleared, setHasDependentCleared] = useState(false);/*this state is used to to clear the options when the parent dropdown data is cleared */

  const params = useParams();
  const { t } = useTranslation();
  const classes = useStyles();
  const formik = useFormikContext();
  const prevValues = useRef({});
  const selectConfig = {
    params: {
      from_select: true,
      allowables: isAllowablesEnabled,
      pagination: isPaginationEnabled,
      page: isPageEnabled,
      page_size: isPageSizeEnabled,    }
  };


  // Grouping utility functions together
  const getOptions = () => {
    if (hasDependentCleared) { /*In this condition dropdown is loaded empty once the parent dropdown is empty*/
      return []

    }
    if (outerOptions) {
      if (discardOptionsByName) {
        const filteredOptions = options.filter((option) => {
          return !discardOptionsByName.includes(option.name);
        });
        return filteredOptions;
      }
      if (discardOptionsByProperties) {
        const keys = discardOptionsByProperties.keys;
        const values = discardOptionsByProperties.values;

        const result = options.filter((option) => {
          return keys.every((key) => {
            return !values.includes(option[key]);
          });
        });
        return result;
      }

      return outerOptions;
    }
    if (options) {
      if (discardOptionsByName) {
        const filteredOptions = options.filter((option) => {
          return !discardOptionsByName.includes(option.name);
        });
        return filteredOptions;
      }
      if (discardOptionsByProperties) {
        const keys = discardOptionsByProperties.keys;
        const values = discardOptionsByProperties.values;

        const result = options.filter((option) => {
          return keys.every((key) => {
            return !values.includes(option[key]);
          });
        });

        return result;
      }

      return options;
    }
    return [];
  };


  // handleChange function for handling select value changes

  const handleChange = (event) => {

    // ... logic for handling value changes ...

    setSelectedValue(null);
    setFetchOptions([])
    getValue ? getValue(event) : null;
    formik.setFieldValue(name);



    if (event) {

      if (isMultiSelect) {
        const selectedIds = event.map((selectedOption) => selectedOption.value);
        // console.log("selectedIds", selectedIds)
        setFetchOptions(event);
        getValue ? getValue(event) : null;
        formik.setFieldValue(name, selectedIds);

      } else {
        setSelectedValue(event);
        // console.log("event.value", event)
        getValue ? getValue(event) : null;
        formik.setFieldValue(name, event.value);
      }


      if (optionsDependsOn && !formik.values[optionsDependsOn]) {

        let selectedValue = options.filter((option) => {
          // console.log('option', option)
          return option.value == event.value
        })
        console.log('selectedValue', selectedValue)

      }
    } else {
      setSelectedValue(null);

      getValue ? getValue(null) : null;
      formik.setFieldValue(name, null);
    }
  };

  const filterOuterOptions = (inputValue) => {
    const filteredOuterOptions = outerOptions.filter((option) =>
      option.name.toLowerCase().includes(inputValue.toLowerCase())
    );
    return mapOldOptionsToNewOptions(filteredOuterOptions);
  };

  const filterGroupedNonPaginatedResponse = (inputValue) => {

    const filteredGroupedNonPaginatedOptions = formattedGroupedOptions.filter(
      (option) => option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    const uniqueFilteredOptions = Array.from(
      new Set(filteredGroupedNonPaginatedOptions.map(JSON.stringify))
    ).map(JSON.parse);

    return mapOldOptionsToNewOptions(uniqueFilteredOptions);
  };

  //TODO: Filter for non grouped non paginated options

  // let optionDependsOnValueOuter;
  // useEffect(() => {
  //   optionDependsOnValueOuter = optionDependsOnValue;
  // }, [optionDependsOnValue]);

  const loadOptions = useCallback((inputValue, callback) => {
    const limitedInputValue = inputValue.slice(0, 20)
    console.log("limitedInputValue", limitedInputValue)

    if (outerOptions) {
      callback(filterOuterOptions(limitedInputValue));
      return;
    }

    if (groupedOptions && options && !paginated) {
      callback(filterGroupedNonPaginatedResponse(limitedInputValue));
      return;
    }

    let newUrl;
    let toFilter = filterOnType ? optionDependsOnValue : optionDependsOnValue;

    if (toFilter) {
      newUrl = `${proxyUrl}?name=${limitedInputValue}&${optionsDependsOn}=${toFilter}`;
    } else if (proxyUrl === `${ROLEMAPPING_FETCH_URL}?id=${params.id}`) {
      newUrl = `${proxyUrl}&name=${limitedInputValue}`;
    } else {
      newUrl = `${proxyUrl}?name=${limitedInputValue}`;
    }

    return eightAxios
      .get(newUrl, selectConfig)
      .then((response) => {
        if (paginated) {
          const responseOptions = response.data.results.map((item) => ({
            value: item.id,
            label: item.name.toUpperCase(),
          }));

          if (optionsDependsOn) {
            setOptions(responseOptions);
          }

          return responseOptions;
        } else {
          const responseOptions = response.data.map((item) => ({
            value: item.id,
            label: item.name.toUpperCase(),
          }));

          return responseOptions;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [proxyUrl, paginated, selectConfig]);

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      textTransform: "uppercase",
    }),

    control: (base, state) => ({
      ...base,
      boxShadow: state.isFocused ? 0 : 0,
      borderColor: state.isFocused ? "#d50910" : base.borderColor,
      "&:hover": {
        borderColor: state.isFocused ? "#d50910" : base.borderColor,
      },
    }),

    singleValue: (provided) => {
      const textTransform = "uppercase";

      return { ...provided, textTransform };
    },
  };

  // Grouping useEffect hooks based on dependencies

  useEffect(() => {
    if (selectedDefaultObjectValue) {
      setSelectedValue(selectedDefaultObjectValue)
      formik.setFieldValue(name, selectedDefaultObjectValue?.value)
      setFetched(true);
      setOptions(options)
      setFetchOptions(options)


    } else {
      if(proxyUrl == ZONE_FETCH_URL){ //this is to empty value once we click add new button for allowable bulk entry
        setSelectedValue(null)
        formik.setFieldValue(name, null)
      }    

    }


  }, [selectedDefaultObjectValue]);

  // useEffect hook for handling changes in dependent options
  useEffect(async () => {

    // ... logic for handling dependent options ...

    if (optionsDependsOn) {

      if (!Array.isArray(formik.values[optionsDependsOn])) { //this condition is to remove the selected value for the child depended dropdown when the parent dropdown value is changed.
        if (prevValues.current[optionsDependsOn] != formik.values[optionsDependsOn]) {
          if (prevValues.current[optionsDependsOn]) {
            formik.setFieldValue(name, selectedDefaultObjectValue?.value || null);
            setSelectedValue(null);
          }
          prevValues.current[optionsDependsOn] = formik.values[optionsDependsOn]
        }

      }
      else {
       
        if (formik.values[optionsDependsOn].length == 0) {
          formik.setFieldValue(name, null);
          setSelectedValue(null);
        }
      }





      if (!formik.values[optionsDependsOn]) {
        setOptions([]);
        setFetchOptions([])
        setHasDependentCleared(true)
        setSelectedValue(isMultiSelect ? [] : null);
        getValue ? getValue(isMultiSelect ? [] : null) : null;
        formik.setFieldValue(name, isMultiSelect ? [] : null);
      }
      else {
        setHasDependentCleared(false)
        const newUrl = `${proxyUrl}?${optionsDependsOn}=${formik.values[optionsDependsOn]}`;

        setOptionDependsOnValue(formik.values[optionsDependsOn]);
        await fetchDataFromApi(newUrl, (data) => {
          let responseData = data;

          if (props.hasAllSelected) {
            const allSelectedObject = hasAllSelected;
            responseData = [...data, allSelectedObject];
          }
          setOptions(responseData);
          setFetchOptions(responseData);
        }, paginated, selectConfig);
        setFetchOptions(options)
        setSelectedValue([])
        if (fetchOptions.length <= 0) {
          setFetchOptions([]);


        }
        if (prevState) {
          formik.setFieldValue(name, isMultiSelect ? [] : null);
          setSelectedValue(isMultiSelect ? [] : null);
          getValue ? getValue(isMultiSelect ? [] : null) : null;
        }
        // console.log("prevState", prevState)

      }

    } else {
      if (isMultiSelect) {
        if (prevValues.current[optionsDependsOn] != formik.values[optionsDependsOn]) {
          formik.setFieldValue(name, null);
          setSelectedValue(null);
        }

      }

      if (proxyUrl && options.length <= 0) {
        if (id) {
          selectConfig.params.id = id
        }
        fetchDataFromApi(proxyUrl, setOptions, paginated, selectConfig);
      }
    }
    //setPrevState(formik.values[optionsDependsOn]);
  }, [formik.values[optionsDependsOn]]);


  // useEffect hook for formatting options when grouped
  useEffect(() => {

    // ... logic for formatting grouped options ...

    if (groupedOptions && options) {
      const formattedOptions = options.map((group) => {
        return group.options;
      });
      setFormattedGroupedOptions(formattedOptions.flat());

    }
  }, [options]);


  useEffect(() => {

    setSelectedValue([]);
  }, [hasNotSupervisor]);

  useEffect(() => {

    setSelectedValue(null);
  }, [hasNoEstates]);
  

  useEffect(() => {
    if (!optionsDependsOn && clear) {
      fetchDataFromApi(proxyUrl, setOptions, paginated);
      setSelectedValue(null);
      getValue ? getValue(null) : null;
      // setClear(false);
    }
    if (!optionsDependsOn && !clear && required) {
      setSelectedValue([]);
      getValue ? getValue([]) : null;
      formik.setFieldValue(name, []);

    }

    if (optionsDependsOn && clear) {
      setFetchOptions([]);
      setOptions([]);
      selectedValue ? setSelectedValue(null) : null;
    }

    if (optionsDependsOn && hasNotSupervisor && !clear) {
      fetchDataFromApi(proxyUrl + '?' + optionsDependsOn + '=' + formik.values[optionsDependsOn], setOptions, paginated);

    }
    if (optionsDependsOn && hasNoEstates && !clear) {
      fetchDataFromApi(proxyUrl + '?' + optionsDependsOn + '=' + formik.values[optionsDependsOn],setOptions,paginated);

    }
    
   
  }, [clear]);
  
    useEffect(() => {
    setSelectedValue(null);
  }, [clearAllowables]);
  

  useEffect(async () => {
   
    if (value) {
      formik.values[name] = value
    }
    if (!optionsDependsOn && !clear) {
      setSelectedValue(value);
    }



    if ((outerOptions || options) && formik.values[name]) {
      if (!isMultiSelect) {
        if (
          selectedValue &&
          !Array.isArray(selectedValue) &&
          selectedValue.value === formik.values[name] &&
          selectedValue.label &&
          selectedValue.label !== selectedValue.value
        ) {
          return;
        }
        let allOptions;
        if (!fetched && !outerOptions) {

          let resp = null
          // if (options.length < 0) {
          //   await eightAxios.get(
          //     `${proxyUrl}?ids[]=${formikValues}`,
          //     selectConfig
          //   );

          // }
          if (paginated && !outerOptions && showSelectedObject) {
            const selectedObject = getOptionFromCurrentValue(
              formik.values["estate"],
              formik.values["estate_name"],
              groupedOptions
                ? [...formattedGroupedOptions]
                : await mapOldOptionsToNewOptions(allOptions)
            );

            const selectedOption = resp ? resp.data.results : options;
            // console.log("selectedOption", selectedOption)


            // Combine selectedObject with the existing selectedOption and remove duplicates
            const combinedOptions = [...selectedOption, selectedObject];
            // console.log("selectedObject", selectedObject)
            const uniqueOptions = Array.from(new Set(combinedOptions.map(JSON.stringify)), JSON.parse);

            setOptions(uniqueOptions);

            setFetched(true);
            allOptions = uniqueOptions;
          }
          if (paginated && !outerOptions) {
            const selectedOption = resp ? resp.data.results : options;
            const updatedOptions = selectedOption.concat(
              options || outerOptions
            );

            const uniqueUpdatedOptions = Array.from(
              new Set(updatedOptions.map(JSON.stringify))
            ).map(JSON.parse);
            // console.log("uniqueUpdatedOptions", uniqueUpdatedOptions)
            setOptions(uniqueUpdatedOptions);
            setFetched(true);
            allOptions = uniqueUpdatedOptions;
          }
        }
        if (allOptions) {

          const selectedObject = getObjectFromCurrentValue(
            value || formik.values[name],
            groupedOptions
              ? [...formattedGroupedOptions]
              : await mapOldOptionsToNewOptions(allOptions)
          );

          setSelectedValue([selectedObject]);
          // console.log("selectedObject", selectedObject)

          getValue ? getValue(selectedObject) : null;
        } else {
          const selectedObject = getObjectFromCurrentValue(
            value || formik.values[name],
            groupedOptions
              ? [...formattedGroupedOptions]
              : mapOldOptionsToNewOptions(getOptions())
          );
          if (selectedObject == undefined || null) {
            setSelectedValue(null);

          }
          else {
            setSelectedValue(selectedObject);
            // console.log("selectedObject", selectedObject)
          }




          getValue ? getValue(selectedObject) : null;
        }
      }
      else {
        let allOptions;
        if (!outerOptions && !fetched && !paginated) {
          const formikValues = formik.values[name];
          // console.log("formikValues", formikValues)

          const valuesForParams = formikValues.map(
            (formikValue) => `ids[]=${formikValue}`
          );
          const modifiedUrl = `${proxyUrl}?${valuesForParams.join("&")}`;

          let resp = null
          if (fetchOptions.length <= 0
            && !hasOptionFetched
          ) {
            setHasOptionFetched(true);
            if (id) {
              selectConfig.params.id = id
            }

            resp = await eightAxios.get(modifiedUrl, selectConfig);
            // console.log('resp fetch options', resp)

            if (resp && !clear) {
              // console.log('resp fetch options',resp)
              setFetchOptions(resp.data?.results || resp.data)
            }




          }

          if (paginated) {
            const selectedOptions = resp ? resp.data.results : options;
            const updatedOptions = selectedOptions.concat(options);
            const uniqueUpdatedOptions = Array.from(
              new Set(updatedOptions.map(JSON.stringify))
            ).map(JSON.parse);
            // console.log("uniqueUpdatedOptions", uniqueUpdatedOptions)

            setOptions(uniqueUpdatedOptions);

            if (formikValues && formikValues.length) setFetched(true);
            allOptions = uniqueUpdatedOptions;
          }
          else {
            const selectedOptions = [...fetchOptions];
            let updatedOptions = options;
            // console.log('selectedOptions', selectedOptions)
            if (!disabled) {
              let isExist = false;
              selectedOptions.forEach(element => {
                isExist = options.some(option =>
                  option.id === element.value || option.id === element.id
                );
                if (!isExist) {
                  updatedOptions.push(element);
                }
              });
            }
            else {
              setFetchOptions([]);
            }
            if (!Array.isArray(updatedOptions)) {
              updatedOptions = updatedOptions?.results ?? []
            }
            const uniqueUpdatedOptions = Array.from(
              new Set(updatedOptions.map(JSON.stringify))
            ).map(JSON.parse);
            setOptions(uniqueUpdatedOptions);
            if (formikValues && formikValues.length)
              setFetched(true);


            allOptions = uniqueUpdatedOptions;
            // console.log("uniqueUpdatedOptions", uniqueUpdatedOptions)
            if (fetchOptions.length > 0) {
              setFetchOptions([])
              setHasOptionFetched(false);


            }
            // console.log("fetchOptionsss", fetchOptions)

            if (formikValues.length) {

              return updatedOptions;

            }
            if (formikValues.length === 0 && clear) {
              setFetchOptions([]);
            }
            else {

              setOptions(uniqueUpdatedOptions)
              // console.log("uniqueUpdatedOptions", uniqueUpdatedOptions)

            }



          }
        }


        if (allOptions) {
          const selectedObjects = getMultipleObjectsForMultiSelect(
            formik.values[name],
            groupedOptions
              ? [...formattedGroupedOptions]
              : mapOldOptionsToNewOptions(allOptions)
          );
          setSelectedValue(selectedObjects);


          getValue ? getValue(selectedObjects) : null;
          setFetched(true);
        }
        else {

          const selectedObjects = getMultipleObjectsForMultiSelect(
            formik.values[name],
            groupedOptions
              ? [...formattedGroupedOptions]
              : mapOldOptionsToNewOptions(getOptions())
          );
          console.log("selectedObjects",selectedObjects)

          const uniqueSelectedObjects = [];

          const unique = selectedObjects.filter(element => {
            const isDuplicate = uniqueSelectedObjects.includes(element.value);

            if (!isDuplicate) {
              uniqueSelectedObjects.push(element.value);

              return true;
            }

            return false;
          });

          
          setSelectedValue(unique);
          getValue ? getValue(selectedObjects) : null;
          setFetched(false);
        }

      }
    } else {

      setSelectedValue(null);
      getValue ? getValue(null) : null;
    }

  }, [outerOptions, options, formik.values[name]]);

 
  return (
    <Field name={name} multiple={isMultiSelect}>
      {(props) => {
        const { meta } = props;
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classes.label, {
                [classes.error]: errorMessage || (meta.error && meta.touched),
              })}
            >
              {t(label)}
              {/* {JSON.stringify(formik.values[name])} */}
              {required ? <span style={{ color: "red" }}> * </span> : null}
              {nationalityInfoIcon ? <HoverTooltip   title={
            <ul>
                <li>1 Nationality can only tag to 1 Language.</li>
                <li>Once the Nationality has been tagged to the Language, the Nationality will no longer display in the multiple picks dropdown.</li>
                <li>If the Nationality is un-tagged from the Language, the option will be available back in dropdown.</li>
            </ul>
        }>
                  <IconButton style={{ padding: "0" }}>
                    <InfoIcon color="primary" />
                  </IconButton>
                </HoverTooltip>
                : null}
                {supervisorInfoIcon ? <HoverTooltip   title={
            <ul>
                <li>For BO User that have Supervisor role, mandatory to fill-in Zone, Region, and Estate information.</li>
                <li>For other roles, it’s optional.</li>
            </ul>
        }>
                  <IconButton style={{ padding: "0",margin: "2px" }}>
                    <InfoIcon color="primary" />
                  </IconButton>
                </HoverTooltip>
                : null}
            </InputLabel>
            <AsyncSelect
              styles={customStyles}
              onBlur={() => formik.setFieldTouched(name, true)}
              maxMenuHeight={250}
              menuPosition={"fixed"}
              isMulti={isMultiSelect}
              defaultInputValue={value}
              isClearable
              // cacheOptions
              placeholder={dynamicLabel ? dynamicLabel : t("Select ") + (t(label) || dynamicLabel)}
              defaultOptions={
                groupedOptions
                  ? options
                  : mapOldOptionsToNewOptions(getOptions())
              }
              value={selectedValue && selectedValue}
              loadOptions={loadOptions}
              onChange={handleChange}
              isDisabled={disabled}
            />
            {errorMessage || (meta.error && meta.touched) ? (
              <ErrorMessage
                message={errorMessage ? errorMessage : meta.error}
              />
            ) : null}
          </>
        );
      }}
    </Field>
  );
};
ReactSelect.propTypes = {
  name: PropTypes.string,
  showSelectedObject: PropTypes.bool,
  id: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array,
  label: PropTypes.string,
  required: PropTypes.bool,
  nationalityInfoIcon:  PropTypes.bool,
  supervisorInfoIcon:  PropTypes.bool,
  outerOptions: PropTypes.array,
  errorMessage: PropTypes.string,
  formik: PropTypes.object,
  proxyUrl: PropTypes.string,
  hasAllSelected: PropTypes.object,
  setOptions: PropTypes.func,
  paginated: PropTypes.bool,
  optionsDependsOn: PropTypes.string,
  editFormData: PropTypes.object,
  groupedOptions: PropTypes.bool,
  discardOptionsByName: PropTypes.array,
  discardOptionsByProperties: PropTypes.array,
  isMultiSelect: PropTypes.bool,
  disabled: PropTypes.bool,
  clear: PropTypes.bool,
  dynamicLabel: PropTypes.string,
  hasNotSupervisor: PropTypes.bool,
  hasNoEstates: PropTypes.bool,
  setClear: PropTypes.bool,
  meta: PropTypes.object,
  field: PropTypes.object,
  getValue: PropTypes.func,
  filterOnType: PropTypes.bool,
  isAllowablesEnabled: PropTypes.bool,
  isPaginationEnabled: PropTypes.bool,
  isPageEnabled: PropTypes.bool,
  isPageSizeEnabled: PropTypes.bool,
  clearAllowables: PropTypes.bool,
  selectedDefaultObjectValue: PropTypes.object,
};

export default ReactSelect;